<template>
    <div @click="go" class="button-back" :class="topMargin ? 'mt-7' : ''">
        <v-icon class="button-back__icon mr-3">mdi-arrow-left-circle</v-icon>
        <span class="button-back__text">{{ label }}</span>
    </div>
</template>

<script>
export default {
    props: {
        button: {
            type: Object,
            default: () => {}
        },
        topMargin: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        go() {
            if (this.route) {
                this.$router.push(this.route)
            } else {
                this.$router.go(-1)
            }
        }
    },
    computed: {
        label() {
            return this.button && this.button.label ? this.button.label : 'Back'
        },
        route() {
            return this.button && this.button.route ? this.button.route : null
        }
    }
}
</script>

<style lang="scss">
.button-back {
    display: flex;
    align-items: center;
    cursor: pointer;

    &__icon {
        color: var(--accent-color) !important;
    }

    &__text {
        font-size: 15px;
        font-weight: 700;
        color: var(--accent-color);
        line-height: 18.3px;
        text-decoration: underline;
    }
}
</style>
